export const templateMapper = (data) => {
    return {
        id: data.id,
        name: data.name,
        type: data.type,
        isDefault: data.isDefault,

        templateUserVariables: !!data.templateUserVariables ?
            data.templateUserVariables.map(v => templateUserVariableMapper(v))
            : [],
    }
}

export const templateUserVariableMapper = (data) => {
    return {
        name: data.name,
        value: data.value,
    }
}